import React, { useState } from 'react';

import {
    Box,
    Flex,
    Text,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Image,
    Grid,
    GridItem,
    SimpleGrid,
    UnorderedList,
    ListItem,
    ListIcon,
    List,
} from '@chakra-ui/react';

import { AddIcon } from '@chakra-ui/icons';

import { Link } from '@chakra-ui/react';

import { BaseSection } from '../../components/BaseSection';

interface LogotypeBarProps {
    logos: LogotypeItem[];
}

interface LogotypeItem {
    url: string;
    alt: string;
}

const LogotypeBar: React.FC<LogotypeBarProps> = ({ logos }) => {
    return (
        <BaseSection>
            <Flex flexWrap={'wrap'} alignItems={'center'}>
                {logos.map((logo, index) => (
                    <Image
                        // maxWidth={{ base: '50%', sm: 'calc(100%/3)', lg: '20%' }}
                        // flex={{ base: '0 0 50%', sm: '0 0 calc(100%/3)', lg: '0 0 20%' }}
                        maxWidth={{ base: '50%', sm: 'calc(100%/3)', lg: 'calc(100%/7)' }}
                        flex={{ base: '0 0 50%', sm: '0 0 calc(100%/3)', lg: '0 0 calc(100%/7)' }}
                        src={logo.url}
                        alt={logo.alt}
                        filter={'grayscale(100%)'}
                    ></Image>
                ))}
            </Flex>
        </BaseSection>
    );
};

export default LogotypeBar;
